export const isEmpty = (item) => Object.keys(item).length === 0;